export default "__VITE_ASSET__24985570__"